import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
  },
  {
    path: '/:meetingId',
    name: 'MeetingDetails',
    component: () => import('@/views/meetings/MeetingDetailsView.vue'),
    props: true
  },
  {
    path: '/:meetingId/clubs',
    name: 'ClubList',
    component: () => import('@/views/clubs/ClubsView.vue'),
    props: true
  },
  {
    path: '/:meetingId/clubs/:clubId',
    name: 'ClubDetails',
    component: () => import('@/views/clubs/ClubDetailsView.vue'),
    props: true
  },
  {
    path: '/:meetingId/clubs/:clubId/athlete/:athleteId',
    name: 'AthleteDetails',
    component: () => import('@/views/athletes/AthleteDetailsView.vue'),
    props: true
  },
  {
    path: '/:meetingId/events',
    name: 'EventList',
    component: () => import('@/views/events/EventsView.vue'),
    props: true
  },
  {
    path: '/:meetingId/events/:eventId',
    name: 'EventDetails',
    component: () => import('@/views/events/EventDetailsView.vue'),
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
